"use client";

import { c as _c } from "react/compiler-runtime";
import { TextInput } from "@mantine/core";
import type { KeyboardEventHandler } from "react";
import SearchIcon from "@/assets/icons/search.svg";
import CrossIcon from "@/assets/icons/crossIcon.svg";
import { cn } from "@/lib/utils";
import styles from "./search-input.module.css";
export type SearchInputProps = Readonly<{
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  stretch?: boolean;
  className?: string;
  maxLength?: number;
  autoFocus?: boolean;
  disabled?: boolean;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  /** When false, hides the leading search icon. Defaults to true. */
  withSearchIcon?: boolean;
}>;
export function SearchInput(t0) {
  const $ = _c(32);
  const {
    value,
    onChange,
    placeholder: t1,
    stretch: t2,
    className,
    maxLength,
    autoFocus,
    disabled,
    onKeyDown,
    withSearchIcon: t3
  } = t0;
  const placeholder = t1 === undefined ? "Search" : t1;
  const stretch = t2 === undefined ? false : t2;
  const withSearchIcon = t3 === undefined ? true : t3;
  const hasValue = value.length > 0;
  let t4;
  if ($[0] !== onChange) {
    t4 = event => onChange(event.currentTarget.value);
    $[0] = onChange;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== withSearchIcon) {
    t5 = withSearchIcon ? <SearchIcon width={16} height={16} aria-hidden={true} /> : undefined;
    $[2] = withSearchIcon;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== withSearchIcon) {
    t6 = withSearchIcon ? {
      className: styles.leftSection
    } : undefined;
    $[4] = withSearchIcon;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== hasValue || $[7] !== onChange) {
    t7 = hasValue ? <button type="button" className={styles.clearButton} aria-label="Clear search" onMouseDown={_temp} onClick={() => onChange("")}><CrossIcon aria-hidden={true} /></button> : null;
    $[6] = hasValue;
    $[7] = onChange;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      className: styles.rightSection
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = hasValue ? "auto" : "none";
  const t10 = stretch && styles.stretch;
  let t11;
  if ($[10] !== className || $[11] !== t10) {
    t11 = cn(styles.root, t10, className);
    $[10] = className;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = hasValue && styles.wrapperWithClear;
  const t13 = !withSearchIcon && styles.wrapperWithoutSearchIcon;
  let t14;
  if ($[13] !== t12 || $[14] !== t13) {
    t14 = cn(styles.wrapper, t12, t13);
    $[13] = t12;
    $[14] = t13;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t11 || $[17] !== t14) {
    t15 = {
      root: t11,
      wrapper: t14,
      input: styles.input,
      section: styles.section
    };
    $[16] = t11;
    $[17] = t14;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== autoFocus || $[20] !== disabled || $[21] !== maxLength || $[22] !== onKeyDown || $[23] !== placeholder || $[24] !== t15 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t9 || $[30] !== value) {
    t16 = <TextInput placeholder={placeholder} value={value} onChange={t4} maxLength={maxLength} autoFocus={autoFocus} disabled={disabled} onKeyDown={onKeyDown} leftSection={t5} leftSectionProps={t6} leftSectionPointerEvents="none" rightSection={t7} rightSectionProps={t8} rightSectionPointerEvents={t9} classNames={t15} />;
    $[19] = autoFocus;
    $[20] = disabled;
    $[21] = maxLength;
    $[22] = onKeyDown;
    $[23] = placeholder;
    $[24] = t15;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t9;
    $[30] = value;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}
function _temp(event_0) {
  return event_0.preventDefault();
}